import React, { useEffect, useState } from "react";
import {
  SearchIcon,
  IncomingIcon,
  CompletedIcon,
  RejectedIcon,
  PendingIcon,
} from "../../assets/svgs/Icons";
import { FiFilter } from "react-icons/fi";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Skeleton,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  Link,
  Select,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  Column,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  sortingFns,
  getSortedRowModel,
  FilterFn,
  SortingFn,
  ColumnDef,
  flexRender,
  FilterFns,
  createColumnHelper,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import moment from "moment/moment";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { getProcurements } from "./ProcurementApprovalSlice";

export const AcceptedProcurements = () => {
  const [status, setStatus] = useState("idle");
  const [columnFilters, setColumnFilters] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const procurementStatus = "APPROVE";
  const dispatch = useDispatch();
  const { allProcurements, isloading } = useSelector(
    (state) => state.procurementApproval
  );

  const navigate = useNavigate();

  const getList = async () => {
    try {
      setStatus("pending");
      const result = dispatch(getProcurements(procurementStatus));
      unwrapResult(result);
      setStatus("success");
    } catch (error) {
      setStatus("failed");
      window.alert(error);
    }
  };

  const updateIncomingData = () => {
    if (allProcurements) {
      const updatedData = allProcurements?.map((d, index) => {
        return {
          ...d,
          srNo: index + 1,
          actions: "actions",
          dateTime: `${moment(d?.createdAt).format("DD-MM-YYYY")}`,
          approvedTime: `${moment(d?.approvedAt).format("DD-MM-YYYY")}`,
          assign_action: "assign_action",
          supplierName: `${d?.procurement_supplier?.firstName} ${d?.procurement_supplier?.lastName}`,
          isUpdated: `${d?.isUpdated ? "True" : "False"}`,
          unitProcesses: d?.applicationForm_process?.map((data) => {
            return data?.name;
          }),
        };
      });

      setUpdatedData(updatedData);
    }
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("srNo", {
      cell: (info) => info.getValue(),
      header: "srNo",
    }),
    columnHelper.accessor("dateTime", {
      cell: (info) => info.getValue(),
      header: "Applied Date",
    }),
    columnHelper.accessor("procurement_company.name", {
      cell: (info) => info.getValue(),
      header: "Company Name",
    }),
    columnHelper.accessor("id", {
      cell: (info) => info.getValue(),
      header: "Procurement Number",
    }),
    columnHelper.accessor(
      (row) => {
        if (row.procurement_supplier && row.procurement_supplier.name) {
          return `${row.procurement_supplier.name} (${
            row?.procurement_supplier?.type || row?.supplierType
          })`;
        } else if (
          row.procurement_supplier &&
          row.procurement_supplier.firstName &&
          row.procurement_supplier.lastName
        ) {
          return `${row.procurement_supplier.firstName} ${row.procurement_supplier.lastName} (${row?.supplierType})`;
        }
        return "";
      },
      {
        cell: (info) => info.getValue(),
        header: "Supplier",
      }
    ),
    columnHelper.accessor("approvedTime", {
      cell: (info) => info.getValue(),
      header: "Approval Date",
    }),
    columnHelper.accessor("procurement_unit.name", {
      cell: (info) => info.getValue(),
      header: "Ginning Unit",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("isUpdated", {
      cell: (info) => info.getValue(),
      header: "Updated By Client",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("procurement_approvedBy.name", {
      cell: (info) => info.getValue(),
      header: "Approved By",
      // meta: {
      //   isNumeric: true,
      // },
    }),

    columnHelper.accessor("actions", {
      Cell: ({ cell }) => console.log({ cell }),
      header: "Actions",
      // meta: {
      //   isNumeric: true,
      // },
    }),
  ];

  const fuzzyFilter = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value);
    // Store the itemRank info
    addMeta({
      itemRank,
    });
    // Return if the item should be filtered in/out
    return itemRank.passed;
  };

  const table = useReactTable({
    data: updatedData || [],
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    // getFacetedRowModel: getFacetedRowModel(),
    // getFacetedUniqueValues: getFacetedUniqueValues(),
    // getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  });

  useEffect(() => {
    getList(procurementStatus);
  }, []);

  useEffect(() => {
    updateIncomingData();
  }, [allProcurements]);

  return (
    <Box>
      {allProcurements?.length > 0 ? (
        <>
          <Box marginTop={"3rem"}>
            <Flex mb="1rem" flexDirection={"row"}>
              <Text> Procurement Approval/ </Text>
              <Text fontWeight={"bold"}>Accepted Applications</Text>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center">
              <Box>
                <InputGroup>
                  <InputLeftElement
                    height={"100%"}
                    pointerEvents="none"
                    children={<SearchIcon color="#B8DEF8" />}
                  />
                  <Input
                    type="text"
                    color={"#464C64"}
                    bg={"#fff"}
                    w={"500px"}
                    h={"48px"}
                    value={globalFilter ?? ""}
                    placeholder="Search All Results"
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    fontSize={"14px"}
                    borderRadius={"10px"}
                    _placeholder={{
                      opacity: 1,
                      color: "#464C64",
                      fontSize: "14px",
                    }}
                  />
                </InputGroup>
              </Box>
              <Box>
                <Box display={"flex"} justifyContent="space-between">
                  <Box>
                    <Box
                      display={"flex"}
                      alignItems="center"
                      marginBottom={"10px"}
                    >
                      <Box
                        as="span"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                        marginRight={"10px"}
                      >
                        <Box as="span" width={"30%"}>
                          {" "}
                          Go to page:{" "}
                        </Box>
                        <Input
                          w={"60%"}
                          type="number"
                          color={"#464C64"}
                          bg={"#fff"}
                          defaultValue={
                            table.getState().pagination.pageIndex + 1
                          }
                          onChange={(e) => {
                            const page = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            table.setPageIndex(page);
                          }}
                        />
                      </Box>
                      <Box>
                        <Select
                          bg="#fff"
                          value={table.getState().pagination.pageSize}
                          onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                          }}
                        >
                          {[10, 20, 30, 40, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                              Show {pageSize}
                            </option>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
          <Box marginTop={"2rem"}>
            <Box
              as="span"
              display="flex"
              alignItems="center"
              marginBottom={"10px"}
              gap="5px"
            >
              <div>Page</div>
              <strong>
                {table.getState().pagination.pageIndex + 1} of{" "}
                {table.getPageCount()}
              </strong>
            </Box>
            <Tabs size="md" variant="enclosed">
              <TableContainer className="overflow-style" overflowX={"scroll"}>
                <Table bg="brand.white" borderRadius="15px">
                  <Thead fontStyle={"normal"}>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => {
                          // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                          const meta = header.column.columnDef.meta;
                          return (
                            <Th
                              key={header.id}
                              color="brand.blue"
                              textTransform="capitalize"
                              onClick={header.column.getToggleSortingHandler()}
                              isNumeric={meta?.isNumeric}
                            >
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                              <Box as="span" pl="1rem">
                                {console.log({
                                  sort: header.column.getIsSorted(),
                                })}
                                {header.column.getIsSorted() ? (
                                  header.column.getIsSorted() === "desc" ? (
                                    <TriangleDownIcon
                                      aria-label="sorted descending"
                                      color={"#3958DC"}
                                      size="20"
                                    />
                                  ) : (
                                    <TriangleUpIcon
                                      aria-label="sorted ascending"
                                      color={"#3958DC"}
                                      size="20"
                                    />
                                  )
                                ) : null}
                              </Box>
                            </Th>
                          );
                        })}
                      </Tr>
                    ))}
                  </Thead>
                  <Tbody>
                    {isloading ? (
                      <>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                      </>
                    ) : (
                      <>
                        {table.getRowModel()?.rows?.map((row) => (
                          <Tr key={row?.id}>
                            {row.getVisibleCells().map((cell) => {
                              // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                              const meta = cell?.column?.columnDef?.meta;
                              return (
                                <Td
                                  key={cell?.id}
                                  isNumeric={meta?.isNumeric}
                                  fontWeight={500}
                                  fontSize="sm"
                                  style={{
                                    maxWidth: "250px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {cell?.renderValue() === "actions" ? (
                                    <Link
                                      color={"#3958DC"}
                                      fontWeight="800"
                                      onClick={() =>
                                        navigate(
                                          `./${encodeURIComponent(
                                            cell?.row?.original?.id
                                          )}`
                                        )
                                      }
                                    >
                                      View Details
                                    </Link>
                                  ) : cell?.renderValue() ===
                                    "assign_action" ? (
                                    <Button
                                    // color={"#3958DC"}
                                    // fontWeight="800"
                                    // onClick={() =>
                                    //   assignToMe(
                                    //     encodeURIComponent(cell?.row?.original?.id)
                                    //   )
                                    // }
                                    >
                                      Assign To Me
                                    </Button>
                                  ) : (
                                    flexRender(
                                      cell?.column?.columnDef?.cell,
                                      cell?.getContext()
                                    )
                                  )}
                                </Td>
                              );
                            })}
                          </Tr>
                        ))}
                      </>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
              <Box
                display={"flex"}
                justifyContent="center"
                marginTop={"1rem"}
                marginBottom="2rem"
              >
                <Box display={"flex"} gap="2rem">
                  <Button
                    className="border rounded p-1"
                    bg="#52BBFF"
                    _hover={{ bg: "#52BBFF" }}
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                  >
                    <AiOutlineArrowLeft color="#141D43" size={18} />
                  </Button>
                  <Button
                    className="border rounded p-1"
                    bg="#52BBFF"
                    _hover={{ bg: "#52BBFF" }}
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                  >
                    <AiOutlineArrowRight color="#141D43" size={18} />
                  </Button>
                </Box>
              </Box>
            </Tabs>
          </Box>
        </>
      ) : (
        <Box
          display={"flex"}
          alignItems="center"
          marginTop={"8rem"}
          justifyContent="center"
        >
          <Text fontSize={"25px"} fontWeight={"bold"} textAlign="center">
            There are no Accepted Procurements yet
          </Text>
        </Box>
      )}
    </Box>
  );
};
